<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Aquisições no Reino Unido e Brasil: Tulip e Marba</h2>
          <p>
            A Pilgrim's fecha a aquisição da <strong>Tulip</strong>, empresa
            líder na produção de carne suína com operações no Reino Unido. A
            compra torna a PCC líder na Europa em proteína e alimentos
            preparados.
          </p>
          <p>
            No Brasil, em linha com a estratégia da companhia de ampliar a
            participação de produtos de maior valor agregado, a
            <strong>Seara</strong> adquire a <strong>Marba</strong>, uma das
            marcas mais tradicionais no segmento de frios e embutidos e
            referência no segmento de mortadelas em São Paulo. No mesmo ano, a
            <strong>Seara</strong> lança ainda a Linha Incrível, que traz a
            opção completa de alimentos 100% vegetais.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2019/2019-1.jpg"
            alt=""
            @click="
              openLink(
                'https://www.estadao.com.br/economia/cade-aprova-aquisicao-do-tradicional-frigorifico-marba-pela-jbs/'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2019/2019-2.png"
            alt=""
            @click="openLink(1)"
            class="secondItem"
          />
          <img
            src="../assets/img/2019/2019-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2019/05/22/g/20190522-45872-nac-26-eco-b6-not-xkggpws.jpg'
              )
            "
            class="terceiroItem"
          />

          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>O <i>plant based</i> em alta</h2>
          <p>
            A busca por novos hábitos alimentares também fez muita gente
            abandonar o consumo de carne e produtos de origem animal. A carne
            vegetal chegou em 2019 ao mercado brasileiro, após anos de maturação
            nos EUA. É uma forma de conciliar alternativas saudáveis e práticas.
            O <strong>Estadão</strong> registrou o movimento na época.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 400px 490px 1fr;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr;
        padding-top: 16px;
        gap: 36px;
        max-height: 600px;
        @include media("<=desktop") {
          padding: 0 20px;
        }

        img .fistItem {
          margin-left: auto;
        }

        .terceiroItem {
          grid-column: 2;
          @include media("<=desktop") {
            margin-top: -50px;
          }
        }

        span {
          position: absolute;
          right: -70px;
          bottom: 50px;
          width: 65px;
          color: color(cBlue4);
          @include media("<=desktop") {
            right: initial;
            left: 30px;
            bottom: 10px;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
            @include media("<=desktop") {
              background: color(cBlue4);
              color: color(cWhite);
            }
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        padding-right: 50px;
        @include media("<=desktop") {
          padding: 30px 20px;
          background: color(cGreen);
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cGreen);
      width: 37%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
